<template>
  <div>
    <video :height="cell.height" controls>
      <source :src="klassifizierungVideo" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </div>
</template>

<script>
import { findKlassifizierung } from './wb-common';
import config from '@/common/config';

export default {
  props: {
    cell: { type: Object, required: true },
    namespace: { type: String, required: true },
    mIndex: { type: String, default: '' },
  },
  computed: {
    input() {
      return this.$store.state[this.namespace].formInput;
    },
    klassifizierungen() {
      return this.$store.state[this.namespace].klassifizierungen;
    },
    klassifizierungVideo() {
      const k = findKlassifizierung(this.klassifizierungen, this.input.klassifizierung);
      if (k !== undefined && k.filename !== undefined) {
        return `${config.apiUrl}/medias/wagenbuch/klassifizierung/${k.filename}/${k.checksum}`;
      }
      return null;
    },
  },
};
</script>
